import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  Input,
  useToast,
  useMediaQuery,
  Badge,
  Card,
  CardBody, CardFooter, CardHeader,
  Tooltip,
} from '@chakra-ui/react'
import { addDoc, collection } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useApp from '../context/AppContext'
import useAuth from '../context/AuthContext'
import db from '../firebase'
import Teams from './Teams.js'

function PlayerCard() {

  const [params] = useSearchParams()
  const toast = useToast()
  const {players, teams, catData,soldPlayers, reservedPlayers, setReservedPlayers} = useApp()
  const {user} = useAuth()
  const [player, setPlayer] = useState(null)
  const [sold, setSold] = useState(null)
  const [reserved, setReserved] = useState(null)
  const [auction, setAuction] = useState(false)
  const [reserve, setReserve] = useState(false)
  const [cost, setCost] = useState(0)
  const [selectedTeam, setSelectedTeam] = useState("")
  const [sellOrReserveButton, setSellOrReserveButton] = useState(false)
  const id = params.get('player')
  const [width] = useMediaQuery("(max-width: 768px)")
  const [widthh] = useMediaQuery("(max-width: 1080px)")

  const navigate = useNavigate()

  const reservePlayer = async () => {

    if(!selectedTeam)
      return;
    
    if(parseInt(cost) < parseInt(catData[player?.category]?.basePrice))
      return;

    setSellOrReserveButton(true)

    const data = {
      tid: selectedTeam,
      pid: player.pid,
      cost: parseInt(cost)
    }

    toast({
      position: 'bottom-right',
      title: `Reserving Player`,
      duration: 2000,
      isClosable: true,
    })

    const reservedData = await addDoc(collection(db, 'reservedplayers'), {...data})
    // console.log(reservedData)

    setReservedPlayers(r => [...r, {
      rid: reservedData._key.path.segments[1],
      ...data
    }])

    toast({
      position: 'bottom-right',
      title: `Player Reserved`,
      status: 'success',
      duration: 2000,
      isClosable: true,
    })
    setSellOrReserveButton(false)
    navigate(-1)
  }


  const startAuction = async () => {
    
    if(!selectedTeam)
      return;
    
    if(parseInt(cost) < parseInt(catData[player?.category]?.basePrice))
      return;

    setSellOrReserveButton(true)
    
    const data = {
      tid: selectedTeam,
      pid: player.pid,
      cost: cost,
      timestamp: new Date()
    }

    toast({
      position: 'bottom-right',
      title: `Selling Player`,
      duration: 2000,
      isClosable: true,
    })

    await addDoc(collection(db, 'soldplayers'), {...data})
    
    toast({
      position: 'bottom-right',
      title: `Player Sold for ${cost}`,
      duration: 2000,
      isClosable: true,
    })

    setSellOrReserveButton(false)
    navigate(-1)
  }

  const goToTop = () => {
    window.scrollTo({ 
      top: 0, 
      behavior: 'smooth',
     });
  }
  useEffect(()=>{
    setTimeout(goToTop, 0);
  },[]);

  useEffect(() => {
    
    if(players?.list?.length > 0)
    {
      setPlayer({...players.players[id]})
    }

  }, [params, players])

  useEffect(() => {
    const isSold = soldPlayers?.filter(s => s.pid === player?.pid)[0]

    if(isSold)
    {
      setSold(isSold)
    }
  }, [player, soldPlayers])

  useEffect(() => {

    const isReserved = reservedPlayers?.filter(s => s.pid === player?.pid)[0]

    if(isReserved)
      setReserved(isReserved)

  }, [player, reservedPlayers])

  
  return (

    <Flex
      direction={'row'}
    >
      <Flex
        direction={"column"}
        boxSizing={'border-box'}
        py={5}
        gap={5}
        px={2}
        w={widthh?"full":'40%'}
        h={'full'}
        position={'relative'}
        justifyContent={'center'}
        transition={'all 0.25s ease'}
        alignItems={width?'center':""}
      >
        
        <Card 
          w="full"
          maxW="full"
          h="full"
          mx="auto"
          position="relative"
          boxShadow="lg"
          borderRadius="md"
          overflow="hidden"
          bg="transparent"
          gap={0}
          // backgroundImage={`url(https://res.cloudinary.com/wtcey4wy/image/upload/v1722541069/pexels-yogendras31-4747325_clm7ds.jpg)`} 
          // backgroundSize="cover"
          // backgroundPosition={'center'}
          // backgroundBlendMode={'overlay'}
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            backgroundImage={`url(https://res.cloudinary.com/wtcey4wy/image/upload/v1722541069/pexels-yogendras31-4747325_clm7ds.jpg)`}
            backgroundSize="cover"
            backgroundPosition="center"
            backgroundBlendMode="multiply"
            backgroundColor={'gray.500'}
            filter="blur(5px)"
            zIndex={-1} // Ensure it's behind the card content

          />
        {sold || reserved?
          <Box
            position="absolute"
            top={3}
            left={1}
            right={0}
            bottom={0}
            w={'100px'}
            h={'20px'}
          >
              <Tooltip             
                label={sold?teams?.teams[sold?.tid].name:teams?.teams[reserved?.tid].name} 
                placement="top"
                hasArrow 
                color={'white'}
                bg={'gray.700'}
                borderRadius={'md'}
                p={2}
                position={'relative'}
              >
                <Button
                   w={'full'}
                   h={'full'}
                   position={'relative'}
                   bg={'transparent'}
                   _hover={{
                     bg:'transparent'
                   }}
                   onClick={() => navigate(`/team?team=${sold?sold?.tid:reserved?.tid}`)}
                >

                {sold?
                  <Badge variant="solid" colorScheme="red" fontSize="12px" px={4} py={2} borderRadius={'md'}>Sold</Badge>:
                  reserved?
                  <Badge variant="solid" colorScheme="red" fontSize="12px" px={4} py={2} borderRadius={'md'}>Reserved</Badge>
                  :<></>
                }
                </Button>
              </Tooltip>
          </Box>:<></>
          }
          <Box
            position={'absolute'}
            bg="gray.400"
          >

          </Box>

           <CardHeader 
            textAlign="center" 
            // bg={"gray.500"} 
            color="white" 
            borderTopRadius="md"
            h={player?.type?"100px":"50px"}
          >
            <Text fontSize="32px" fontWeight="bold" color="gray.300">
              {player?.name}
            </Text>
            {player?.type && <Text fontSize="20px" fontWeight="bold" color="gray.300">
              {player?.type}
            </Text>}
          </CardHeader>

          <CardBody>
            <Flex direction="column" align="center" gap={4}>
              <Flex
                gap={2}
              >
              <Badge variant="subtle" colorScheme="teal" fontSize="16px" px={4} py={1}>
                {player?.category}
              </Badge>
              <Badge variant="subtle" colorScheme="teal" fontSize="16px" px={4} py={1}>
                {catData[player?.category]?.basePrice}
              </Badge>
              </Flex>
              {/* <Text fontSize="18px" color="gray.600">
                Category: <span style={{ fontWeight: 'bold' }}>{player?.category}</span>
              </Text> */}
              {/* <Text fontSize="18px" color="gray.600">
                Base Price: <span style={{ fontWeight: 'bold' }}>{catData[player?.category]?.basePrice}</span>
              </Text> */}
              
              <Box w="full" h="full" position="relative"
                // background={'gray.500'}
              >
                <Image 
                  w="full" 
                  h="full" 
                  src={player?.image} 
                  borderRadius="md" 
                  objectFit="contain"
                  background={'gray.500'}
                  // top="-25%"  // Adjust these values to control the size and position of the image
                  // left="-25%"
                  // right="-25%"
                  // bottom="-25%"
                  boxShadow='dark-lg'
                />
              </Box>
              
              {/* <Text fontSize="16px" color="gray.300">
                Membership No.: <span style={{ fontWeight: 'bold' }}>{player?.mid}</span>
              </Text> */}
            </Flex>
          </CardBody>

          <CardFooter
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="center" 
            gap={0} 
            w="full"
            // height={"200px"}
            // background={'rgba(0,0,0,0.5)'}
          >
            <Flex 
              direction="column" 
              align="center" 
              w="full" 
              gap={2} p={1} 
              borderRadius="md"
              // background={'rgba(0,0,0,0.5)'}

            >
              <Text fontSize="18px" fontWeight="bold" color="gray.300">Last Tournament Stats</Text>
              <Flex
                gap={4}
                justify="center"
              >
              <Badge variant="solid" colorScheme="teal" fontSize="12px" px={4} py={1} borderRadius={'sm'}>{player?.score || 0} Runs</Badge>
              <Badge variant="solid" colorScheme="teal" fontSize="12px" px={4} py={1} borderRadius={'sm'}>{player?.wickets || 0} Wickets</Badge>
              </Flex>
              
              <Flex wrap="wrap" gap={3} mt={4} justify="center">
                {player && Object.keys(player?.atts).map(key => (
                  player.atts[key] && (
                    <Badge
                      key={key}
                      variant="outline"
                      fontSize={14}
                      px={2}
                      py={2}
                      borderRadius={'md'}
                      colorScheme='teal'
                    >
                      {key}
                    </Badge>
                  )
                ))}
              </Flex>
            </Flex>
            
          {!sold && !reserved && user?
          <Flex
            justifyContent={'space-around'}
            align={'center'}
            // backgroundColor={'rgba(0,0,0,0.5)'}
            // gap={2}
            my={2}
          >

          <Flex
          gap={2}
          >
            <Button onClick={() => setAuction(true)}>Auction</Button>
            <Button onClick={() => setReserve(true)}>Reserve</Button>
            
          </Flex>
          </Flex>
          :""}
          </CardFooter>
          

        </Card>

        <Flex
          w={'100%'}
          h={'100%'}
          position={'fixed'}
          top={0}
          left={0}
          bottom={0}
          right={0}
          background={'rgba(0,0,0,0.5)'}
          zIndex={'1'}
          backdropFilter={'blur(10px)'}
          opacity={auction || reserve?1:0}
          transform={auction || reserve?'translateY(0)':'translateY(-200%)'}
          transition={'all 0.25s ease'}
          p={5}
          alignItems='center'
          direction={'column'}
        >
          <Flex
            justifyContent={'space-between'}
            w="full"
          >
            <Flex
              alignItems={'center'}
              gap={5}
            >

              <Input
                type={'number'}
                onChange={(e) => setCost(e.target.value)}
                value={cost===0?null:cost}
                w={200}
              />
              
              <Text>Base Price: {catData[player?.category]?.basePrice}</Text>

            </Flex>
            {auction?
              <Button onClick={() => setAuction(false)}>X</Button>
              :
              reserve?
              <Button onClick={() => setReserve(false)}>X</Button>
              :""
            }
          </Flex>

          <Flex
            wrap={'wrap'}
            gap={2}
            py={5}
            justifyContent="space-evenly"
          >

            {teams?.list.map(t => {

                if(cost - catData[player?.category]?.basePrice > teams?.teams[t]?.extraPoints)
                return <></>

                if(catData[player?.category]?.basePrice > teams?.teams[t]?.reservedPoints)
                return <></>

                if(catData[player?.category]?.limit <= teams.teams[t]?.counts[player?.category])
                return <></>

                return (
                  <Flex
                    px={3}
                    py={1}
                    direction="column"
                    bg={selectedTeam===t?"cyan.700":'rgba(0,0,0,0.2)'}
                    borderRadius={"10px"}
                    cursor={'pointer'}
                    transition={"all 0.25s ease"}
                    _hover={{
                      bg:'rgba(255,255,255,0.2)'
                    }}
                    onClick={() => setSelectedTeam(t)}
                  >
                    <Text>
                      {teams.teams[t].name}
                    </Text>
                    <Text fontSize={'12px'} color={'gray.400'}>Points: {teams.teams[t].points}</Text>
                  </Flex>
                )}
            )}
            
          </Flex>
          
          {user && auction?
          <Button
            onClick={() => startAuction()}
            bottom={10}
            w="90%"
            m="auto"
            position={'absolute'}
            disabled={sellOrReserveButton}
          >Sell Player to {selectedTeam?teams.teams[selectedTeam].name:""}
          </Button>:""
          }
          {user && reserve?
          <Button
            onClick={() => reservePlayer()}
            bottom={10}
            w="90%"
            m="auto"
            position={'absolute'}
            disabled={sellOrReserveButton}
          >Reserve Player to {selectedTeam?teams.teams[selectedTeam].name:""}
          </Button>:""
          }
                  
        </Flex>

      </Flex>

    {widthh?<></>: <Teams playerCard={true} basePrice={catData[player?.category]?.basePrice}/>}
    </Flex>
  )
}

export default PlayerCard
